import axios from 'axios'

const host = "https://api.reanimate.com.br/api/";

const api = axios.create({
    baseURL: host
  })
  
export default api